import { useCompoundComponentLifecycle } from '../CompoundComponentProvider/hooks/useCompoundComponentLifecycle.mjs';
import { CompoundComponentValue } from '../CompoundComponentProvider/CompoundComponentProvider.mjs';

function Title(props) {
  useCompoundComponentLifecycle(CompoundComponentValue.Title, props);
  return null;
}

export { Title };
